import React, { Component } from 'react';
import AssetSection from './AssetSection';
import FormField from './../../../forms/FormField';
import { Field, FormSection } from 'redux-form';

import Column from './Column';

class OrSelector extends Component {
  constructor(props) {
    super(props);
    this.state = { selected: null }
  }
  render() {
    const { asset, readOnly } = this.props;
    const { fields, opts } = asset || {};
    const options = (fields || []).map(f => {
      const { name, label } = f.opts || {};
      return {
        value: name,
        label
      }
    });

    const value = this.state.selected || (options[0] || {}).value;

    const selected = fields.find(f => f.opts.name === value);

    const handleChange = (e) => {
      const { value } = e.target;
      this.setState({ selected: value });
    }

    return (
      <Column field={asset}>
        <div>
          {!readOnly && (
            <div className="pull-right">
              <select onChange={handleChange} value={value}>
                {(options || []).map(o => (
                  <option value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          )}
          <h3>{opts.label}</h3>
        </div>
        {selected && (
          <AssetSection asset={selected} readOnly={readOnly}/>
        )}
      </Column>
    )
  }
}

export default OrSelector



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/OrSelector.js